/**
 * ZoneSeatSummary Repository
 * 구역별 좌석 현황 데이터 저장소
 */
import { ZoneSummary, ZoneSeatDetail } from '../models/ZoneSeatSummary';
import { API_BASE_URL } from '../../../config/api';

/**
 * 인증 헤더 생성
 */
function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem('accessToken');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

export class ZoneSeatSummaryRepository {
  /**
   * 구역 목록 조회
   */
  async getZones(orgId: string): Promise<ZoneSummary[]> {
    const response = await fetch(`/v1/seat-config/zones`, {
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      throw new Error('구역 정보를 불러오는데 실패했습니다');
    }

    return await response.json();
  }

  /**
   * 구역별 좌석 상세 정보 조회
   * TODO: 백엔드 API 수정 필요 (zone_id가 문자열인데 API는 정수를 예상)
   */
  async getZoneSeatDetail(zoneId: number, orgId: string): Promise<ZoneSeatDetail> {
    // 임시로 기본 데이터 반환
    return {
      zone_id: zoneId,
      zone_code: String(zoneId),
      zone_name: `구역 ${zoneId}`,
      total_seats: 0,
      available_seats: 0,
      occupied_seats: 0,
      maintenance_seats: 0,
      occupancy_rate: 0,
    };
  }

  /**
   * 모든 구역의 좌석 상세 정보 조회
   */
  async getAllZoneSeatDetails(
    zones: ZoneSummary[],
    orgId: string
  ): Promise<Record<number, ZoneSeatDetail>> {
    const seatDetailsMap: Record<number, ZoneSeatDetail> = {};

    for (const zone of zones) {
      try {
        const seatData = await this.getZoneSeatDetail(zone.id, orgId);
        seatDetailsMap[zone.id] = {
          ...seatData,
          zone_name: zone.name,
        };
      } catch (err) {
        console.error(`구역 ${zone.id} 좌석 정보 로드 실패:`, err);
      }
    }

    return seatDetailsMap;
  }
}

export const zoneSeatSummaryRepository = new ZoneSeatSummaryRepository();
